/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type ReactElement, createContext, forwardRef } from 'react';
import { Collection, type ContextValue, TableHeader as TableHeaderCore, type TableHeaderProps as TableHeaderCoreProps, useContextProps, useTableOptions } from 'react-aria-components';
import { Checkbox } from '../checkbox/checkbox.component';
import { Column } from '../column/column.component';

interface TableHeaderProps<T> extends Omit<TableHeaderCoreProps<T>, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
  /** Whether to show a checkbox in the header for selection. @default false */
  withCheckbox?: boolean;
}

const TableHeaderContext = createContext<ContextValue<TableHeaderProps<object>, HTMLDivElement>>({});

const TableHeader = forwardRef((props: TableHeaderProps<object>, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, TableHeaderContext);

  const { style, children, columns, withCheckbox = false, ...coreProps } = props;

  const { selectionBehavior, selectionMode } = useTableOptions();

  return (
    <TableHeaderCore
      ref={ref}
      {...stylex.props(style)}
      {...coreProps}>
      {selectionBehavior === 'toggle' && withCheckbox &&
        <Column isPadded width={43}>
          {selectionMode === 'multiple' && <Checkbox slot="selection" isIndeterminate />}
        </Column>}
      <Collection items={columns}>
        {children}
      </Collection>
    </TableHeaderCore>
  );
}) as <T>(p: TableHeaderProps<T> & { ref?: ForwardedRef<HTMLTableSectionElement> }) => ReactElement;

export { TableHeader, TableHeaderContext, type TableHeaderProps };
